import React from "react";
import ColorField from "./ColorField";

export default function ColorGroupSection({ title, fields, values, onChange, cols = 2 }) {
  const colSize = Math.max(1, Math.min(12, Math.floor(12 / cols)));
  const colClass = `col-12 col-md-${colSize}`;

  return (
    <div className="mb-4">
      <h4 className="h6 mb-3 d-flex align-items-center" style={{ gap: 8 }}>
        <div style={{ width: 6, height: 20, borderRadius: 4, background: '#FF7A1A' }} />
        <span className="mb-0">{title}</span>
      </h4>
      <div className="row g-2">
        {fields.map(({ key, label }) => (
          <div className={colClass} key={key}>
            <ColorField
              label={label}
              value={typeof values === "object" && values !== null ? values[key] : undefined}
              onChange={(val) => onChange(key, val)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}